import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BodySpecialToolbarFilter from './BodySpecialToolbarFilter';
import BodySpecialToolbarSearch from './BodySpecialToolbarSearch';
import { labels } from '../../../../../../util/utils';
import { debounce } from 'lodash';

function BodySpecialToolbar({
	className,
	bodyTypeId,
	searchPlaceholder,
	hideSearchBox,
	onFilterChange,
	children,
	isTypeAhead = false
}) {
	const [searchValue, setSearchValue] = useState('');

	const debouncedOnFilterChange = useRef(debounce((name, value) => onFilterChange(name, value), 500));

	const handleOnSearchButtonClick = useCallback(
		(value) => {
			let _searchtext = value?.currentTarget?.value;
			if (onFilterChange) {
				setSearchValue(_searchtext);
				debouncedOnFilterChange.current('searchString', _searchtext?.trim() || null);
			}
		},
		[onFilterChange]
	);

	const handleOnSearchClear = useCallback(() => {
		if (onFilterChange) {
			setSearchValue('');
			onFilterChange('searchString', null);
		}
	}, [onFilterChange]);

	return (
		<StyledBodySpecialToolbar className={`StyledBodySpecialToolbar ${className}`}>
			{!hideSearchBox && (
				<BodySpecialToolbarSearch
					placeholder={searchPlaceholder}
					onClear={handleOnSearchClear}
					onSearchButtonClick={handleOnSearchButtonClick}
					onChange={handleOnSearchButtonClick}
					searchHoverText={searchPlaceholder}
					clearHoverText={labels.clearHoverText}
					value={searchValue}
					styleName="BodySpecialToolbarSearch"
				/>
			)}
			{children}
		</StyledBodySpecialToolbar>
	);
}

BodySpecialToolbar.propTypes = {
	hideSearchBox: PropTypes.bool,
	className: PropTypes.string,
	bodyTypeId: PropTypes.number.isRequired,
	onFilterChange: PropTypes.func,
	searchPlaceholder: PropTypes.string,
	children: PropTypes.node
};

BodySpecialToolbar.defaultProps = {
	className: 'body-special-toolbar',
	filter: false,
	searchPlaceholder: labels.searchPlaceholder
};

export default BodySpecialToolbar;

const StyledBodySpecialToolbar = styled.section`
	display: flex;
	padding-right: var(--px-5);
	margin: 0 0 var(--px-24) 0 !important;
	.BodySpecialToolbarSearch {
		width: var(--px-370);
	}
	.motif-form-field {
		margin: 0 !important;
	}
`;
